import { makeStyles } from '@rbx/ui';
import { engineRevampMonospaceTextStyle } from '@modules/ui/shared/utils/styles';

const useReferenceInheritedMembersStyles = makeStyles()((theme) => {
  return {
    container: {
      marginBottom: '12px',
    },
    titleLink: {
      ...engineRevampMonospaceTextStyle,
      display: 'inline',
      color: theme.palette.content.standard,
      marginRight: '4px',
    },
    inheritedGroupTitle: {
      fontSize: '16px',
    },
    accordionGroup: {
      backgroundColor: theme.palette.surface[0],
      boxShadow: 'none',
      border: 'none',
      marginBottom: '12px',
      '&:before': { display: 'none' },
    },
    summary: {
      color: theme.palette.content.muted,
      backgroundColor: 'transparent',
      minHeight: 'auto',
      padding: '0px',
      position: 'relative',
      '& .MuiAccordionSummary-content': {
        margin: '0px',
        paddingLeft: '24px', // reserve space for absolute chevron
      },
      '& .MuiAccordionSummary-expandIconWrapper': {
        position: 'absolute',
        left: '0px',
        top: '50%',
        transform: 'translateY(-50%) rotate(0deg)',
        color: theme.palette.content.muted,
      },
      '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'translateY(-50%) rotate(90deg)',
      },
    },
    details: {
      padding: '0px',
      backgroundColor: theme.palette.surface[0],
    },
    detailsContent: {
      width: '100%',
      paddingLeft: '28px',
      marginTop: '12px',
    },
  };
});

export default useReferenceInheritedMembersStyles;
